import React from 'react';
import {
  UcatTimedPreScreen,
  UcatSubtestTable,
  ucatBodyText,
  ucatSectionHeading,
} from './UcatTimedPreScreen';
import { UCAT_SUBTEST_LABELS } from '../utils/ucatSubtests';

const FALLBACK_ROWS = {
  decision_making: { name: 'Decision Making', questions: '35', ucat: '37 minutes', extra: '46 minutes 15 seconds' },
  quantitative_reasoning: { name: 'Quantitative Reasoning', questions: '36', ucat: '26 minutes', extra: '32 minutes 30 seconds' },
  situational_judgement: { name: 'Situational Judgement', questions: '69', ucat: '26 minutes', extra: '32 minutes 30 seconds' },
};

/**
 * DM / QR / SJ intros. Duration is unnamed until WP0 records it —
 * do not default to 60s or 1:30. When durationSeconds is omitted, Next only (no auto-advance).
 */
const UcatSubtestInstructionsScreen = ({
  examName = 'UCAT',
  paperTitle,
  colorScheme,
  setColorScheme,
  onNext,
  onEndExam,
  moduleKey,
  questionCount,
  durationMinutes,
  extraTimeLabel,
  durationSeconds,
  pearsonSitting = true,
}) => {
  const fallback = FALLBACK_ROWS[moduleKey] || FALLBACK_ROWS.decision_making;
  const label = UCAT_SUBTEST_LABELS[moduleKey] || fallback.name;
  const count = Number(questionCount) > 0 ? String(questionCount) : fallback.questions;
  const minutes = Number(durationMinutes) > 0 ? `${durationMinutes} minutes` : fallback.ucat;
  const extra = extraTimeLabel || fallback.extra;
  const heading = `${label.toUpperCase()} INSTRUCTIONS`;
  const timed = Number(durationSeconds) > 0;

  return (
    <UcatTimedPreScreen
      examName={examName}
      paperTitle={paperTitle}
      colorScheme={colorScheme}
      setColorScheme={setColorScheme}
      onNext={onNext}
      onEndExam={onEndExam}
      durationSeconds={timed ? durationSeconds : undefined}
      autoAdvance={timed}
      showHelp
      showEndExam={Boolean(onEndExam)}
      pearsonSitting={pearsonSitting}
    >
      {({ ink, scheme }) => {
        const body = ucatBodyText(ink);
        const section = ucatSectionHeading(ink);
        return (
          <>
            {timed ? (
              <p style={{ ...body, fontWeight: 700 }}>
                You have time to read this screen.
              </p>
            ) : null}
            <p style={{ ...section, fontSize: '16px', marginBottom: '16px' }}>{heading}</p>
            <UcatSubtestTable
              ink={ink}
              scheme={scheme}
              rows={[{ name: label, questions: count, ucat: minutes, extra }]}
            />
            <p style={body}>For each question you may only select one response, unless the item asks otherwise.</p>
            <p style={body}>
              It is in your best interest to answer all questions as there is no penalty for guessing. Unanswered questions will be scored as incorrect.
            </p>
            <p style={body}>
              The <strong>&apos;Navigator&apos;</strong> function at the bottom right of the screen allows you to navigate to questions within the subtest.
            </p>
            <p style={body}>
              Refer to the <strong>Help</strong> button for guidance on problems during testing. Test time will continue to count down while using the Help button.
            </p>
            <p style={{ ...body, marginBottom: 0 }}>
              Please click the{' '}
              <strong>
                Next (<span style={{ textDecoration: 'underline' }}>N</span>)
              </strong>{' '}
              button to proceed
              {timed ? ' before the time on this screen expires' : ''}
              .
            </p>
          </>
        );
      }}
    </UcatTimedPreScreen>
  );
};

export default UcatSubtestInstructionsScreen;
